
import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const auth_sso_configuration: Configuration = {
    auth: {
        clientId: 'b0ae6422-1197-431e-a927-558ac3f8ce0f',
        authority: 'https://login.microsoftonline.com/20923150-f613-4b38-af27-a5dd1cb27af1',
        redirectUri: '/signin-oidc',
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: false,
        secureCookies: true
    },
    system: {
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                //console.log(logLevel, message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }
    }
}

export const AUTH_SSO_MSAL = {
    protectedResourceMap: new Map([
        ['https://prodDeutschInstitutBack.azurewebsites.net*', ['api://a721048d-5d6d-4fd6-9ea0-b0d31f9ad2f4/Deutsch-Institut-Back']],
        ['https://devdeutshinstituteapi.azurewebsites.net/*', ['api://a721048d-5d6d-4fd6-9ea0-b0d31f9ad2f4/Deutsch-Institut-Back']],
        ['https://intdeutschinstitutback.azurewebsites.net/*', ['api://a721048d-5d6d-4fd6-9ea0-b0d31f9ad2f4/Deutsch-Institut-Back']],
        ['http://localhost:4200/*', ['api://a721048d-5d6d-4fd6-9ea0-b0d31f9ad2f4/Deutsch-Institut-Back']]
    ]),
}

